export default {
  title: 'Подтвердите личность',
  subtitle: 'Введите последние 4 цифры телефона пациента или номера заказа, чтобы просмотреть данные доставки.',
  'type-phone': 'Телефон пациента (последние 4 цифры)',
  'type-order': 'Номер заказа (последние 4 цифры)',
  code: 'Последние 4 цифры',
  submit: 'Продолжить',
  'attempts-remaining': 'Осталось попыток: {count}',
  blocked: 'Слишком много попыток. Повторите через {minutes} мин.',
  'invalid-code': 'Неверный код. Попробуйте снова.',
  expired: {
    title: 'Ссылка недоступна',
    description: 'Доступ к заказу закрыт (срок просмотра 14 дней истёк).',
  },
  forbidden: {
    title: 'Доступ запрещён',
    description: 'У вас нет прав для просмотра этой страницы.',
  },
}
